/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ManualCaptureLoggedPayload
 */
export interface ManualCaptureLoggedPayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: ManualCaptureLoggedPayloadTypeEnum;
    /**
     * 
     */
    captureId: string;
    /**
     * 
     */
    nickname?: string | null;
    /**
     * 
     */
    weightGrams?: number | null;
    /**
     * 
     */
    lengthMm?: number | null;
}


/**
 * @export
 */
export const ManualCaptureLoggedPayloadTypeEnum = {
    ManualCaptureLogged: 'manual_capture_logged',
} as const;
export type ManualCaptureLoggedPayloadTypeEnum = typeof ManualCaptureLoggedPayloadTypeEnum[keyof typeof ManualCaptureLoggedPayloadTypeEnum];


/**
 * Check if a given object implements the ManualCaptureLoggedPayload interface.
 */
export function instanceOfManualCaptureLoggedPayload(value: object): value is ManualCaptureLoggedPayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'manual_capture_logged') return false;
    
    if ((!('captureId' in (value as Record<string, any>)) && !('capture_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['captureId'] === undefined && (value as Record<string, any>)['capture_id'] === undefined)) return false;
    return true;
}

export function ManualCaptureLoggedPayloadFromJSON(json: any): ManualCaptureLoggedPayload {
    return ManualCaptureLoggedPayloadFromJSONTyped(json, false);
}

export function ManualCaptureLoggedPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManualCaptureLoggedPayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
        'captureId': json['capture_id'],
        'nickname': json['nickname'] === undefined ? undefined : json['nickname'] === null ? null : json['nickname'],
        'weightGrams': json['weight_grams'] === undefined ? undefined : json['weight_grams'] === null ? null : json['weight_grams'],
        'lengthMm': json['length_mm'] === undefined ? undefined : json['length_mm'] === null ? null : json['length_mm'],
    };
}

export function ManualCaptureLoggedPayloadToJSON(json: any): ManualCaptureLoggedPayload {
    return ManualCaptureLoggedPayloadToJSONTyped(json, false);
}

export function ManualCaptureLoggedPayloadToJSONTyped(value?: ManualCaptureLoggedPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
        'capture_id': value['captureId'],
        'nickname': value['nickname'],
        'weight_grams': value['weightGrams'],
        'length_mm': value['lengthMm'],
    };
}

